<input matInput readonly [formControl]="dateControl" [matDatepicker]="datepicker" [min]="min"
  [max]="max" (click)="datepicker.open()">
<mat-datepicker #datepicker startView="year" [calendarHeaderComponent]="calendarHeader"
  (monthSelected)="writeValue($event);onChange($event);datepicker.close()"></mat-datepicker>
